<template>
  <div class="signup-step2">
    <p>
      {{
        mode === 'email'
          ? $t('login.send-mail-tip', { mail: body.email })
          : $t('login.send-sms-tip', { phone: body.tel.phone })
      }}
    </p>
    <EncryptCode ref="codeInput" v-model="code" show-type="text" />
    <div class="resend-wrap">
      <div>
        <ErrorTips v-show="error" :value="error" />
      </div>
      <Loading v-if="loading" size="sm" />
      <span
        v-else
        class="countdown-or-resend"
        :class="{ 'resend-able-btn': countDown < 1 }"
        @click="resendCode"
      >
        {{
          countDown > 0
            ? $t('resetPsw.resent', { second: countDown })
            : $t('resetPsw.resend')
        }}
      </span>
    </div>
    <div class="signup-footer">
      <Button
        type="submit"
        :disabled="isSignupBtnDisabled"
        :loading="subimtLoading"
        theme="primary"
        @click="submit"
      >
        {{ $t('login.button') }}
      </Button>
      <Button type="submit" @click="setStep('1')">
        {{ $t('login.cancel') }}
      </Button>
    </div>
    <NoticeBox ref="notice" />
    <GeetestCheck
      ref="geetest"
      target=".panel"
      @validate-pass="geetestPass"
      @ready="loading = false"
    />
  </div>
</template>
<script>
import EncryptCode from 'com/EncryptCode'
import Loading from 'com/Loading'
import Button from 'com/Button'
import ErrorTips from '../ErrorTips'
import NoticeBox from '../NoticeBox'
import registerMixin from './registerMixin'
import { ERROR_CODE } from 'const/common'
export default {
  name: 'RegisterStep2',
  components: {
    EncryptCode,
    ErrorTips,
    NoticeBox,
    Button,
    Loading
  },
  mixins: [registerMixin],
  computed: {
    isSignupBtnDisabled() {
      const code = this.code
      if (code && code.length === 6 && !this.error && !this.loading) {
        return false
      }
      return true
    }
  },
  watch: {
    code(value) {
      // 重置验证码，不清空错误
      if (value) {
        this.clearError()
      }
    }
  },
  data() {
    return {
      loading: false,
      subimtLoading: false,
      code: '',
      signupSuccess: false // 是否
    }
  },
  methods: {
    submit() {
      this.$track('login_signup_button')
      this.subimtLoading = true
      this.signupSuccess = false
      this.clearError()
      this.$store
        .dispatch('userSignup', { ...this.params, verify_code: this.code })
        .catch(error => {
          const errorCode = error.error_code
          // 非验证码类型错误回退到第一页
          const needCode =
            ERROR_CODE.VERIFY_ERROR_CODES.indexOf(errorCode) !== -1
          if (!needCode) {
            // 其他报错情况需要到第一步，错误信息同步到第一步
            this.setStep('1')
          }
          this.code = ''
          this.$refs.codeInput.focus()
          this._errorHandler(error)
        })
        .finally(() => {
          this.subimtLoading = false
        })
    },
    resendCode() {
      if (this.countDown > 0) {
        return
      }
      this.initGeetest()
    }
  }
}
</script>
